// extracted by mini-css-extract-plugin
export default {"ScreenshotDialog":"ScreenshotDialog_ScreenshotDialog__TCzo2","ScreenshotContainer":"ScreenshotDialog_ScreenshotContainer__l-vK3"};